/**
 * 鐘點 → 時辰地支 + 晚子時換日（Asia/Hong_Kong 本地鐘點，唔做真太陽時）。
 * 對齊上游 README：23:00–23:59 → 次日、hour=0；00:00–00:59 → 當日、hour=0。
 */
import type { BirthInfo } from './engine/ziwei/types';
import { BRANCHES, SHICHEN } from './engine/ziwei/constants';

export function clockToBranch(hour: number, minute: number): number {
  const mins = hour * 60 + minute;
  if (mins >= 23 * 60 || mins < 60) return 0;
  return Math.floor((mins - 60) / 120) + 1;
}

export function addDays(y: number, m: number, d: number, delta: number): { year: number; month: number; day: number } {
  const dt = new Date(Date.UTC(y, m - 1, d + delta));
  return { year: dt.getUTCFullYear(), month: dt.getUTCMonth() + 1, day: dt.getUTCDate() };
}

export interface ClockBirth {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  gender: 'male' | 'female';
  name?: string;
}

export function toBirthInfo(input: ClockBirth): BirthInfo {
  const branch = clockToBranch(input.hour, input.minute);
  let y = input.year;
  let m = input.month;
  let d = input.day;
  const lateZishi = input.hour === 23;
  if (lateZishi) {
    const n = addDays(y, m, d, 1);
    y = n.year;
    m = n.month;
    d = n.day;
  }
  return {
    year: y,
    month: m,
    day: d,
    hour: branch,
    gender: input.gender,
    name: input.name,
    origInput: {
      year: input.year,
      month: input.month,
      day: input.day,
      clockHour: input.hour,
      clockMinute: input.minute,
    },
  };
}

export function branchLabel(branch: number): string {
  return `${BRANCHES[branch] ?? '?'}時（${SHICHEN[branch]?.range ?? ''}）`;
}
